<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chapter-title" id="ch-1"><a id="page_3"><strong>A. Constitutional Exemptions Before <em>Smith</em></strong></a></h1><a id="page_3">
<p class="para">All the material in this Section was written before the Court’s decision in <em>Employment Division v. Smith.</em> It addresses illustrative cases litigated under the pre-<em>Smith</em> regime. There are two amicus briefs and two short articles addressed to religious audiences.</p>
<p class="indent-para">The law before <em>Smith</em> was much better for churches and believers than the law after <em>Smith</em>, but even before <em>Smith</em> these cases were hard to win. Indeed, the religious claimant lost each of the cases in this Section.</p>
<h1 class="sec3" id="sec3-1"><strong>The Briefs …</strong></h1>
<p class="para1">In <em>Mozert v. Hawkins County Public Schools</em> (1987), parents sought to exempt their children from using a reader that undermined their religious faith.</p>
<p class="indent-para">In <em>Jimmy Swaggart Ministries v. Board of Equalization</em> (1990), Swaggart sought to exempt the sale of religious books and recordings from the California sales and use tax.</p>
<p class="indent-para">Briefs are not hard to read. For a quick guide to their main peculiarity, see the third-to-last paragraph of the Preface to this volume.</p>
<h1 class="sec3" id="sec3-2"><strong>… and the Articles</strong></h1>
<p class="para1"><em>Peyote, Wine, and the First Amendment</em> is an explanation of the issues in <em>Employment Division v. Smith</em> and why Christians should care about those issues, written before the case was decided, when religious liberty scholars all thought it would be decided under then-existing law.</p>
</a><p class="indent-para"><a id="page_3"></a><a id="page_4"><em>Churches Are Living on Borrowed Time</em> is an interview about the <em>Swaggart</em> case, after it was decided.</a></p><a id="page_4">
<h1 class="sec3" id="sec3-3"><strong>Cross References</strong></h1>
<p class="para1">All the entries in this Section are short. My most substantial scholarly treatment of the exemption issue prior to <em>Smith</em> is in <em>A Survey of Religious Liberty in the United States</em>, in Volume 1.</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 009_Chapter01.vue?cb2d795c